<template lang="pug">
//- VitePwaManifest
GlobalError(v-if="isEmbed")
.embed-error(v-if="isEmbed && isEmbedRedirectError")
  v-label Une erreur s'est produite lors de la redirection, cliquez pour recharger.
  v-btn.primary(@click="onReloadFromEmbed") Recharger
v-app.main
  login(v-if='!isExternal && !isEmbed')
  .overlay(v-show='isLoading')
    v-progress-circular.loader(indeterminate='', color='primary')
  .page(v-show='!isLoading')
      slot
</template>

<script setup lang="ts">
import { handleAuthToken } from '~/utils/handleAuthToken'
import { preload } from '~/utils/preload'
const navigationStore = useNavigationStore()
const isEmbedRedirectError = ref<Boolean>(false)
const reloadUrl = ref<string | null>(null)
const { $api: api, $toast: toast, $host: host } = useNuxtApp()
const isLoading = ref(true)

let oldPath: any = null
onMounted(async () => {
  const userStore = useUserStore()
  if (userStore.token) {
    await preload()
  }
  isLoading.value = false
})

const isEmbed = computed(() => {
  return navigationStore.embed
})

const isExternal = computed(() => {
  return navigationStore.external
})

const listenerMessageFromMobile = (event: any) => {
  const { data } = event
  switch (data.type) {
    case 'redirect':
      handleAuthToken(data.query.authToken)
      if (data.query && data.id) {
        data.query.id = data.id
      }
      navigateTo({ path: data.path, query: data.query })
      if ((!data.path || (oldPath && oldPath === data.path)) && navigationStore.embed) {
        onRedirectSuccessFromIOS(data.id)
        isLoading.value = false
      }
      oldPath = data.path
      break
    case 'redirect-failed':
      reloadUrl.value = `${window.location.origin}${data.payload.path}?${new URLSearchParams(data.payload.query).toString()}`
      isEmbedRedirectError.value = true
      isLoading.value = false
      break
    case 'show-overlay':
      isLoading.value = true
      break
    case 'hide-overlay':
      isLoading.value = false
      break
    default:
      break
  }
}

const onReloadFromEmbed = () => {
  isEmbedRedirectError.value = false
  if (reloadUrl.value !== null) window.location.href = reloadUrl.value as string
}

onMounted(() => {
  host.subscribeListener(listenerMessageFromMobile)
})
onUnmounted(() => {
  host.unSubscribeListener(listenerMessageFromMobile)
})
</script>

<style lang="stylus" scoped>
.embed-error
  width 100%
  height 100%
  background #fff
  position absolute
  top 0
  left 0
  z-index 10000
  display flex
  align-items center
  justify-content center
  flex-direction column
  gap 10px
  .v-label
    opacity 1
    font-size 1.2rem
    font-weight 500
    white-space pre-wrap
    text-align center
    padding 30px

.main
  background var(--white)
  margin auto
  overflow auto

  .page
    height 100%

  .spacer
    width 100%
    height 120px

  .overlay
    position absolute
    z-index 100
    height 100vh
    width 100vw
    top 0
    left 0
    background-color var(--white, #FFFFFF)
    opacity 1
    .loader
      position absolute
      top 50%
      left 50%
</style>
